import {base64UrlDecode} from '@/utils/portuna';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import dateHelper from '../utils/portuna/dateHelper';

const SickNoteList                 = () => import('../views/sick-note/SickNoteList.vue');
const SickNoteStatistic            = () => import('../views/sick-note/SickNoteStatistic.vue');
const SickNoteStatisticAbsenceRate = () => import('../views/sick-note/SickNoteStatisticAbsenceRate.vue');
const SickNoteStatisticMonthly     = () => import('../views/sick-note/SickNoteStatisticMonthly.vue');

let sickNoteMeta = {
    module: 'employee',
};

let sickNote: RouteRecordRaw[] = [
    {
        name: 'sick-note',
        path: '/employee/sick',
        redirect: {name: 'sick-note-list'},
        meta: sickNoteMeta,
    },
    {
        name: 'sick-note-index',
        path: '/employee/sick/index',
        redirect: {name: 'sick-note-list'},
        meta: sickNoteMeta,
    },

    //<editor-fold desc="List">
    {
        name: 'sick-note-list',
        path: '/employee/sick/list/:filter?',
        component: SickNoteList,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                missing: 0,
                filter: route.params.filter ? JSON.parse(base64UrlDecode(route.params.filter)) : {},
            };
        },
    },
    {
        name: 'sick-note-missing-list',
        path: '/employee/sick/missingSicknotes',
        component: SickNoteList,
        meta: sickNoteMeta,
        props()
        {
            return {
                missing: 1,
            };
        },
    },
    //</editor-fold>
    // <editor-fold desc="Statistic">
    {
        name: 'sick-note-statistic-year',
        path: '/employee/statistic/sick-note-year/:id(\\d+)?/:year(\\d{4})?/entity/:entity(\\d+)?',
        alias: [
            '/employee/sickyear/statistics/:id?/:year?',
            '/employee/sickyear/statistics/id/:id?',
            '/employee/sickyear/statistics/id/:id?/year/:year?',
            '/employee/statistic/sick-note-year/:id(\\d+)?/:year(\\d{4})?',
        ],
        component: SickNoteStatistic,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                year: parseInt(route.params.year) || dateHelper('Y'),
                type: 'year',
                entity: parseInt(route.params.entity) || 0,
            };
        },
    },
    {
        name: 'sick-note-statistic-month',
        path: '/employee/sickmonth/statistics/:year?/:all?',
        alias: '/employee/sickmonth/statistics/year/:year?',
        component: SickNoteStatistic,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                year: parseInt(route.params.year) || dateHelper('Y'),
                all: route.params.all === 'all',
                type: 'month',
            };
        },
    },
    {
        name: 'sick-note-statistic-week',
        path: '/employee/sickweek/statistics/:year?/:all?',
        alias: '/employee/sickweek/statistics/year/:year?',
        component: SickNoteStatistic,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                year: parseInt(route.params.year) || dateHelper('Y'),
                all: route.params.all === 'all',
                type: 'week',
            };
        },
    },
    {
        name: 'sick-note-statistic-monthly',
        path: '/employee/statistic/sick-note-month/:year(\\d{4})?/:month(\\d{1,2})?',
        alias: '/employee/sick/statistics-month/:year(\\d{4})?/:month(\\d{1,2})?',
        component: SickNoteStatisticMonthly,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: parseInt(route.params.year) || parseInt(<string>dateHelper('Y')),
                month: parseInt(route.params.month) || parseInt(<string>dateHelper('m')),
            };
        },
    },
    {
        name: 'sick-note-statistic-absence-rate',
        path: '/employee/sick/statistics-absence-rate/:workState(\\w+)?/:entity(\\d+)?/:state(current|past|all|year)?/:year(\\d{4})?',
        component: SickNoteStatisticAbsenceRate,
        meta: sickNoteMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                workState: route.params.workState || 'all',
                entity: route.params.entity ? parseInt(route.params.entity) : 0,
                state: route.params.state ? route.params.state : 'current',
                year: route.params.year ? parseInt(route.params.year) : 0,
            };
        },
    },
    //</editor-fold>
];

export default sickNote;